// @ts-strict-ignore
import { requestApi } from 'api/api'
import {
  ForgotPasswordReq,
  ForgotPasswordResponse,
  ResetPasswordReq,
  ResetPasswordResponse,
} from 'types/passwords'

export const postForgotPassword = async ({
  emailAddress,
  recaptcha,
  recaptchaVersion,
}: ForgotPasswordReq): Promise<ForgotPasswordResponse> => {
  return requestApi({
    url: `/user/forgot/request`,
    method: 'POST',
    data: { emailAddress, recaptcha, recaptchaVersion },
    authenticated: false,
  })
}

export const postResetPassword = async ({
  newPassword,
  token,
  recaptcha,
  recaptchaVersion,
}: ResetPasswordReq): Promise<ResetPasswordResponse> => {
  return requestApi({
    url: '/user/forgot/confirm',
    method: 'POST',
    data: { newPassword, token, recaptcha, recaptchaVersion },
    authenticated: false,
  })
}
